module.exports = __webpack_public_path__ + "media/images/icons/upload-ef446f2d522279901f66435d5b4bb6a4.svg";